import { PlateEditor } from '@udecode/plate';
import { generateText } from './commands/generateText';
import { getPrompt } from './commands/getPrompt';
import { unwrapGeneratedContent } from './commands/unwrapGeneratedContent';

export const withGeneratedContent = (editor: PlateEditor) => {
  editor.generateText = ({ organizationId, action, annotation }) =>
    generateText({
      editor,
      organizationId,
      action,
      annotation,
    });

  editor.prompt = () => getPrompt({ editor });

  editor.keepGeneratedContent = () => unwrapGeneratedContent({ editor });

  editor.highlighted = null;
  editor.hasGeneratedContent = false;

  return editor;
};
